import React from 'react';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import { Box, Tab as MuiTab, styled } from '@mui/material';

import theme from '../../config/theme';
import { getActiveTab } from '../../store/car-slice';
import { useSelector } from 'react-redux';

type TabLabels = 'Exterior' | 'Interior' | 'Videos' | 'Gallery' | 'Video Tour';

type TabVelus = 'exterior' | 'interior' | 'videos' | 'gallery' | 'videoTour';

type PropTypes = {
  label: TabLabels;
  handleClick: any;
  value: TabVelus;
  iconCondition?: boolean;
  iconRender?: boolean;
};

const Tab = styled(MuiTab)<any>(({ textColor }) => ({
  px: '22px',
  fontWeight: 600,
  color: textColor,
  alignSelf: 'center',
  minHeight: 48,
  [theme.breakpoints.down('lg')]: {
    fontSize: 9.2,
    padding: 0,
  },
  fontSize: 16,
  textTransform: 'capitalize',
}));

export default function CustomTab(props: PropTypes) {
  const {
    label,
    handleClick,
    value,
    iconCondition,
    iconRender = false,
  } = props;

  const activeTab = useSelector(getActiveTab);

  const textColor = activeTab === value ? 'white !important' : '#ffffff99';

  const icon = iconCondition ? (
    <Box
      sx={{
        display: 'flex',
        color:
          value === activeTab
            ? 'white !important'
            : 'rgba(255, 255, 255, 0.60)',
      }}
    >
      <KeyboardArrowUpRoundedIcon
        sx={{
          [theme.breakpoints.down('lg')]: {
            fontSize: 20,
          },
        }}
      />
    </Box>
  ) : (
    <Box
      sx={{
        display: 'flex',
        color:
          value === activeTab
            ? 'white !important'
            : 'rgba(255, 255, 255, 0.60)',
      }}
    >
      <KeyboardArrowDownRoundedIcon
        sx={{
          [theme.breakpoints.down('lg')]: {
            fontSize: 20,
          },
        }}
      />
    </Box>
  );

  return (
    <Tab
      icon={iconRender ? icon : undefined}
      iconPosition="end"
      label={label}
      onClick={handleClick}
      textColor={textColor}
    />
  );
}
